import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const StyledAnchor = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "ecgc78b0"
} : {
  target: "ecgc78b0",
  label: "StyledAnchor"
})(process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "e0dnmk",
  styles: "cursor:pointer/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvcGFja2FnZXMvc2hhcmVkL3NyYy9jb21wb25lbnRzL2NvbW1vbi9iYXNlLWxpbmsvc3R5bGVzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFb0MiLCJmaWxlIjoiL2FwcC9wYWNrYWdlcy9zaGFyZWQvc3JjL2NvbXBvbmVudHMvY29tbW9uL2Jhc2UtbGluay9zdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbmNob3IgPSBzdHlsZWQuYWBcbiAgY3Vyc29yOiBwb2ludGVyO1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});